import React from "react";

import classnames from "classnames";

import style from "./checkbox.module.scss"

export default class Checkbox extends React.Component {
	state={value:false};

	render() {
		let className = classnames(style.checkmark);
		if(this.props.color) {
			className = classnames(className, style[this.props.color])
		}
		return (
			<label className={style.container}>
				<input type="checkbox" className={style.check} onChange={this.props.onCheck} checked={this.props.checked === true}/>
				<span className={className}/>
			</label>
		);
	}
}
